import { RouteRecordRaw } from 'vue-router'

const renwumingxi: Array<RouteRecordRaw> = [{
    path: '/renwumingxi',
    meta: {
        title: "战队用户数据明细"
    },
    component: () => import("@/views/renwumingxi/list.vue")
}];
export default renwumingxi;